export default __webpack_public_path__ + "static/media/man.4b684e29.svg";